import { styled } from 'styled-components';

import { ForaLogo, MenuCloseIcon } from '../../../assets/icons';
import { Container, Flex } from '../../Layout';
import { Assets } from '../../../assets';
import { theme } from '../../../styles';
import { Headings } from '../../Headings';
import { Button } from '../../Button';

type LoginLoadingScreenProps = {
  onCancel: () => void;
};

const LogoContainer = styled(Container)`
  position: absolute;
  top: 2.5rem;
  left: 1.25rem;

  @media screen and (min-width: ${theme.breakpoint.md}px) {
    top: 5rem;
    left: 6.5rem;
  }

  @media screen and (min-width: ${theme.breakpoint.lg}px) {
    top: 5rem;
    left: 5rem;
  }
`;

export const LoginLoadingScreen = ({ onCancel }: LoginLoadingScreenProps) => {
  return (
    <Flex
      position="relative"
      justifyContent="center"
      alignItems="center"
      paddingTop={160}
      paddingBottom={160}
      paddingRight={20}
      paddingLeft={20}
      height="100%"
    >
      <LogoContainer>
        <ForaLogo color="white" width={160} />
      </LogoContainer>
      <Flex alignItems="center" flexDirection="column" rowGap={40}>
        <Headings.H3 color="white">Var god vänta</Headings.H3>
        <Assets.Spinner
          color="white"
          width={100}
          strokeWidth={10}
          data-testid="test-processing-in-progress-loading-element"
        />
        <Button
          testId="test-button-cancel-bank-id-loading"
          fontSize="medium"
          styleAs="link"
          variant="primary"
          onClick={onCancel}
          style={{ color: 'white' }}
        >
          <MenuCloseIcon color="white" marginRight={5} title="Avbryt" containerSize={13} />
          Avbryt inloggningen
        </Button>
      </Flex>
    </Flex>
  );
};
